<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2022-10-25 09:45:23
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-03-07 10:09:15
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/WeMeet_admin_project/wemeet-admin/src/views/dragger/template/tpl_exhibition.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<!--
* @description:
* @fileName tpl_page.vue
* @author hvv
* @date 2022/02/15 16:15:54
!-->
<template>
  <div class="shopItem">
    <img alt="" class="imgBox" :src="res.listCover" />
    <div class="contentBox">
      <div class="name">{{ res.meetingName || res.name }}</div>
    </div>
  </div>
</template>

<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, toRefs, watch, computed } from 'vue'
  export default defineComponent({
    name: 'tpl_page.vue',
    props: {
      res: {
        type: Object,
      },
    },
    setup(props) {},
  })
</script>
<style lang="scss" scoped>
  .shopItem {
    .imgBox {
      width: 100%;
      height: 160px;
      object-fit: contain;
    }
    .contentBox {
      box-sizing: border-box;
      width: 100%;
      height: 60px;
      padding: 10px;
    }
  }
</style>
